<ui-card-page>
	<ng-container modal-header>
		<div style="margin-top: 35px;" class="resume_header">
			<h1 class="resume_header__title">{{ this.puip.form_billing.title1 }} <span
				style="font-size: 16px;">{{ this.puip.form_billing.title2 }}</span></h1>
			<h1 class="resume_header__title"><span
				style="font-size: 16px;">{{ this.puip.form_billing.title3 }}</span> {{ this.puip.form_billing.title4 }}
			</h1>
		</div>
	</ng-container>
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body__form">
				<ng-container [formGroup]="puip.userInfoFrom">
					<ibk-input-group>
						<label>Documento</label>
						<div class="input-inline">
							<ibk-select
								class="field"
								dsRxForm="selectChange"
								formControlName="{{puip.formItems['doc_type'].control}}"
								style="width: 80px;"
								minlength="2"
							>
								<ibk-select-option value="DNI" label="DNI" selected></ibk-select-option>
								<ibk-select-option value="CE" label="CE"></ibk-select-option>
							</ibk-select>
						</div>
						<div class="input-inline">
							<ibk-input class="field" char-filter="^[0-9]{1,8}$" style="width: 236px">
								<input class="field" required formControlName="{{puip.formItems.dni.control}}"
								       [disabled]="true"/>
							</ibk-input>
						</div>
						@if (puip.getErrors('dni')) {
							<div class="resumen_body__form__error">{{ puip.getErrors('dni') }}</div>
						}
					</ibk-input-group>

					<ibk-input-group>
						<label>Nombres</label>
						<div class="input-inline">
							<ibk-input class="field">
								<input id="name" has-error="true" required class="field"
								       formControlName="{{puip.formItems.name.control}}" [disabled]="true"
								       style="width: 320px;"/>
							</ibk-input>
							@if (puip.getErrors('name')) {
								<div class="resumen_body__form__error">{{ puip.getErrors('name') }}</div>
							}
						</div>
					</ibk-input-group>
					<ibk-input-group>
						<label>Apellidos</label>
						<div class="input-inline">
							<ibk-input class="field">
								<input class="field" formControlName="{{puip.formItems.lastname.control}}"
								       [disabled]="true" style="width: 320px;"/>
							</ibk-input>
							@if (puip.getErrors('lastname')) {
								<div class="resumen_body__form__error">{{ puip.getErrors('lastname') }}</div>
							}
						</div>
					</ibk-input-group>

					<ibk-input-group>
						<label>Email</label>
						<div class="input-inline">
							<ibk-input class="field">
								<input class="field" formControlName="{{puip.formItems.email.control}}"
								       [disabled]="true" style="width: 320px;"/>
							</ibk-input>
							@if (puip.getErrors('email')) {
								<div class="resumen_body__form__error">{{ puip.getErrors('email') }}</div>
							}
						</div>
					</ibk-input-group>

					<ibk-input-group>
						<label>Celular</label>
						<div class="input-inline">
							<ibk-input class="field">
								<input class="field" formControlName="{{puip.formItems.phone.control}}"
								       [disabled]="true" style="width: 320px;"/>
							</ibk-input>
							@if (puip.getErrors('phone')) {
								<div class="resumen_body__form__error">{{ puip.getErrors('phone') }}</div>
							}
						</div>
					</ibk-input-group>

					<ibk-input-group>
						<ibk-button>
							<button style="width: 248px; margin-top: 24px;"
							        class="ibk-btn ibk-btn--primary"
							        (click)="actionAccept()">
								Aceptar
							</button>
						</ibk-button>
					</ibk-input-group>

				</ng-container>
			</div>
		</div>
	</ng-container>


</ui-card-page>
